import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { Box, Input } from 'core/ui/atoms';
import { EditHeading, EditBlock } from 'days/ui/atoms';

import withUpdateNight from 'nights/ui/withUpdateNight';

@withUpdateNight
class NightAuthor extends PureComponent {
  static propTypes = {
    author: PropTypes.string,
    updateNight: PropTypes.func,
  };

  state = {
    author: this.props.author || '',
  };

  save = debounce(() => {
    const { author } = this.state;
    this.props.updateNight({ author });
  }, 1000);


  handleChange = (e) => {
    this.setState({ author: e.target.value });
    this.save();
  };

  render() {
    const { author } = this.state;
    return (
      <EditBlock>
        <Box width="100%">
          <EditHeading>Автор цитаты:</EditHeading>
          <Input type="text" value={author} onChange={this.handleChange}/>
        </Box>
      </EditBlock>
    );
  }
}

export default NightAuthor;

